import { ReactNode } from 'react';
import { Root, LeftContainer, RightContainer, ActionBarType, Clamp } from './top-action-bar.styles';
import { TextType, Text } from '../../io/text';
import { useTheme } from 'styled-components';
export interface TopActionBarProps {
    children: ReactNode;
    header: string;
    description: string;
    actionBarType?: keyof typeof ActionBarType;
}
export function TopActionBar({
    children,
    header,
    description,
    actionBarType = ActionBarType.info,
}: TopActionBarProps) {
    const theme = useTheme();
    const fg =
        actionBarType === ActionBarType.info ? theme.foreground.light : theme.foreground.default;
    return (
        <Root $actionBarType={actionBarType}>
            <LeftContainer>
                <Clamp lines={1}>
                    <Text type={TextType.descriptionMedium} color={fg}>
                        {header}
                    </Text>
                </Clamp>
                <Clamp lines={2}>
                    <Text type={TextType.description} color={fg}>
                        {description}
                    </Text>
                </Clamp>
            </LeftContainer>

            <RightContainer>{children}</RightContainer>
        </Root>
    );
}
